module.exports = __webpack_public_path__ + "static/media/testStall.f43fb819.png";